import React from 'react';
import { useLocation } from '../nav';
import { Splash } from '../pages/Splash';
import { Login } from '../pages/Login';
import { Home } from '../pages/Home';
import { Chat } from '../pages/Chat';
import { Transfer } from '../pages/Transfer';
import { Draft } from '../pages/Draft';
import { Review } from '../pages/Review';
import { Success } from '../pages/Success';
import { History } from '../pages/History';
import { Bills } from '../pages/Bills';
import { Profile } from '../pages/Profile';
import { Account } from '../pages/Account';

/** Renders the live app screen for the current in-memory route. */
export function ScreenView() {
  const {
    pathname
  } = useLocation();
  switch (pathname.split('?')[0]) {
    case '/':
    case '/splash':
      return <Splash data-id="element-140" data-mp="1yaqaknf5r59e" />;
    case '/login':
      return <Login data-id="element-141" data-mp="11r95uqtr4xl8" />;
    case '/home':
      return <Home data-id="element-142" data-mp="11s2ejxc9tx60" />;
    case '/chat':
      return <Chat data-id="element-143" data-mp="11qradwewyned" />;
    case '/transfer':
      return <Transfer data-id="element-144" data-mp="15supcv0ska4e" />;
    case '/draft':
      return <Draft data-id="element-145" data-mp="15rt4jytz499h" />;
    case '/review':
      return <Review data-id="element-146" data-mp="15qrqrmlkp8o2" />;
    case '/success':
      return <Success data-id="element-147" data-mp="3hf3czr7sp86d" />;
    case '/history':
      return <History data-id="element-148" data-mp="3he215kiyghnl" />;
    case '/bills':
      return <Bills data-id="element-149" data-mp="3cficvdgw2ts2" />;
    case '/profile':
      return <Profile data-id="element-150" data-mp="3cf8ofubhsuoh" />;
    case '/account':
      return <Account data-id="element-151" data-mp="3cga6iiqxehfp" />;
    default:
      return <Splash data-id="element-152" data-mp="37oigqaflgfqm" />;
  }
}